<template>
  <span>
    <b-dropdown variant="link" no-caret>
      <template slot="button-content">
        <span class="text-secondary text-uppercase mr-1">
          {{ language }}
          <i class="fa fa-caret-down" />
        </span>
      </template>
      <b-dropdown-item
        v-for="(lang, key) in availableLanguages"
        v-bind:key="key"
        href="#"
        class
        @click="$store.dispatch('setLanguage', lang)"
      >
        <b v-if="language === lang">{{ $t('NAVIGATION_language_' + lang) }}</b>
        <span v-else>{{ $t('NAVIGATION_language_' + lang) }}</span>
      </b-dropdown-item>
    </b-dropdown>

    <span class="mr-1">
      <template v-if="isLoggedIn">
        <b-dropdown right variant="link">
          <template slot="button-content">
            <div class="profileLink text-dark">
              <template v-if="user.firstName || user.lastName"
                >{{ user.firstName }} {{ user.lastName }}</template
              >
              <template v-else>{{ $t('NAVIGATION_item_profile') }}</template>
            </div>
          </template>
          <b-dropdown-item @click="$router.push({ name: 'profile' })">{{
            $t('NAVIGATION_item_profile')
          }}</b-dropdown-item>
          <b-dropdown-item
            @click="goToFavs"
            v-if="user.portal === 'RHEUMAFIT'"
            >{{ $t('NAVIGATION_item_my_favs') }}</b-dropdown-item
          >
          <b-dropdown-divider />
          <b-dropdown-item @click.prevent="logout">
            {{ $t('NAVIGATION_item_logout') }}
          </b-dropdown-item>
        </b-dropdown>
      </template>
      <template v-else>
        <b-button variant="primary" @click="login">{{ $t('login') }}</b-button>
      </template>
    </span>

    <feature name="log" tag="span">
      <b-button
        v-if="isLoggedIn && user.canUseLog"
        @click="goToLog"
        variant="primary"
        >{{ $t('NAVIGATION_item_log') }}</b-button
      >
    </feature>

    <feature name="physio" tag="span">
      <template v-if="isPhysio">
        <b-button @click="goToPhysio" variant="physio">{{
          $t('NAVIGATION_item_physio')
        }}</b-button>
      </template>
    </feature>
  </span>
</template>

<script>
import { mapState } from 'vuex';
import { mapGetters } from 'vuex';

import Loader from '@/components/Loader';
import config from '@/config';

export default {
  name: 'navigation',
  components: { Loader },
  computed: {
    ...mapState(['language']),
    ...mapGetters(['user', 'isLoggedIn', 'isPhysio']),
  },
  data() {
    return { availableLanguages: config.availableLanguages };
  },
  methods: {
    goToProfile(tabIndex = null) {
      if (tabIndex === null) {
        this.$router.push({ name: 'profile' });
      } else {
        this.$router.push({ name: 'profile_index', params: { tabIndex } });
      }
    },
    login() {
      this.$store.dispatch('openLoginModal');
    },
    goToFavs() {
      this.$router.push({ name: 'home' });
      this.$store.dispatch('resetFilter');
      this.$store.dispatch('setFilter', { favorites: true });
      this.$store.commit('setIsFilterOpen', false);
    },
    goToPhysio() {
      this.$router.push({ name: 'physio' });
    },
    goToLog() {
      const { protocol, host } = window.location;
      const domain = host.split('.').slice(-2).join('.');
      window.location.href = ['rheumafit.ch', 'rheumafit.dev'].includes(
        domain
      )
        ? `${protocol}//log.${domain}`
        : 'http://localhost:3000';
    },
    logout() {
      this.$store.dispatch('logout');
    },
  },
};
</script>

<style lang="scss" scoped>
.profileLink {
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
  overflow: hidden;
  position: relative;
  top: 5px;

  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }

  @media screen and (max-width: 500px) {
    max-width: 120px;
  }

  @media screen and (max-width: 400px) {
    max-width: 70px;
  }
}
</style>



// WEBPACK FOOTER //
// src/elements/LoginIndicator/desktop.vue